import * as React from "react";
import styled from "styled-components";

import { ItemLabel } from "../../../App/Common/Components/FormComponents";
import colors from "../../../styles/colors";
import { NarrowButton } from "./Buttons";
import { FormContainer, Input } from "./FormElements";

const InsertButton = styled(NarrowButton)`
  background: ${colors.blue};
  color: ${colors.white};
`;

interface IFileUploadProps {
  linkInputName: string;
  fileInputName: string;
  uploadFile: (
    fileInputRef: React.RefObject<HTMLInputElement>,
    linkInputRef: React.RefObject<HTMLInputElement>
  ) => () => void;
}

const FileUpload: React.SFC<IFileUploadProps> = ({ fileInputName, linkInputName, uploadFile }) => {
  const linkInputRef: React.RefObject<HTMLInputElement> = React.createRef();
  const fileInputRef: React.RefObject<HTMLInputElement> = React.createRef();

  return (
    <FormContainer>
      <ItemLabel htmlFor={linkInputName}>Add file by link:</ItemLabel>
      <Input name={linkInputName} ref={linkInputRef} />
      <InsertButton onClick={uploadFile(fileInputRef, linkInputRef)}>Insert</InsertButton>
      <ItemLabel htmlFor={fileInputName}>Add file by upload:</ItemLabel>
      <Input ref={fileInputRef} name={fileInputName} type="file" onInput={uploadFile(fileInputRef, linkInputRef)} />
    </FormContainer>
  );
};

export default FileUpload;
